import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import { isEmpty } from 'lodash';
import InfoText from '../MUI/IntoText';
import TitleTypography from '../MUI/TitleTypography';
import MainCheckbox from '../MUI/MainCheckbox/MainCheckbox';

import useStyles from './makeStyles';

const InfoBlock = ({
  formProps,
  hasAgreed,
  handleAgreementClick,
  showInfoBlock,
  infoBlockText,
  agreementText,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      {showInfoBlock && (
        <div className={classes.infoBlock}>
          <InfoText textInfo={t(infoBlockText)} withHTML />
        </div>
      )}
      <div className={classes.infoBlock}>
        <Grid container spacing={1} className={classes.agreementBlock}>
          <Grid item>
            <label className={classes.checkboxAndClaim}>
              <MainCheckbox
                checked={hasAgreed}
                onChange={handleAgreementClick}
                color="primary"
                name="hasAgreed"
                inputRef={formProps.register}
                className={isEmpty(formProps.errors.hasAgreed) ? '' : classes.invalidCheckbox}
              />
              <TitleTypography
                className={isEmpty(formProps.errors.hasAgreed) ? '' : classes.invalidAgree}
              >
                {t('paymentConfirmation.agree')}
              </TitleTypography>
            </label>
          </Grid>
          <Grid item>
            <div className={classes.infoText}>
              <p
                    // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: t(agreementText),
                }}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

InfoBlock.propTypes = {
  handleAgreementClick: PropTypes.func.isRequired,
  hasAgreed: PropTypes.bool.isRequired,
  formProps: PropTypes.shape({
    register: PropTypes.func,
    errors: PropTypes.shape({
      hasAgreed: PropTypes.shape({}),
    }),
  }).isRequired,
  showInfoBlock: PropTypes.bool,
  infoBlockText: PropTypes.string,
  agreementText: PropTypes.string,
};

InfoBlock.defaultProps = {
  showInfoBlock: false,
  infoBlockText: '',
  agreementText: '',
};

export default InfoBlock;
